/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Requests_Desc_PersonalInputs */



/**
* | output |
* | --- |
* | "Your daily API request pattern" |
*
* @param {Dashboard_Requests_Desc_PersonalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_requests_desc_personal = /** @type {((inputs?: Dashboard_Requests_Desc_PersonalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Requests_Desc_PersonalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein tägliches API-Anfragenmuster")
	return /** @type {LocalizedString} */ ("Your daily API request pattern")
});